module.exports = __webpack_public_path__ + "img/2.08a203d2.jpg";